import { useSelector } from "react-redux";
import Pill from "../CategoryHeader/Pill";
import HorizontalScrollList from "../HorizontalScrollList";
import styles from "./index.css";
import { TRANSLATION_KEY_FACETED_NAV_CAROUSEL } from "../HorizontalScrollList/constants";
import { getCategorySeoLinks } from "../../state/modules/category/selectors";

const SecondaryCategorySeoLinks = () => {
  const { secondarySeoLinks } = useSelector(getCategorySeoLinks);

  if (!secondarySeoLinks.length) return null;

  return (
    <HorizontalScrollList
      className={styles.secondaryCategorySeoLinks}
      ariaLabel={TRANSLATION_KEY_FACETED_NAV_CAROUSEL}
    >
      {secondarySeoLinks.map(({ friendlyName, linkUrl }) => (
        <Pill
          key={friendlyName}
          friendlyName={friendlyName}
          linkUrl={linkUrl}
        />
      ))}
    </HorizontalScrollList>
  );
};

export default SecondaryCategorySeoLinks;
